/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-lines */

import { upsertCustomerContacts } from 'actions/customerContacts';
import Modal from 'components/Modal';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { getCustomerContacts } from 'selectors/customerContacts';
import { useSelector } from 'store';

type ComponentProps = {
  isModalOpen: boolean;
  toggleModalOpen: () => void;
};

const EditCustomerContactsModal: React.FC<ComponentProps> = ({ isModalOpen, toggleModalOpen }) => {
  const dispatch = useDispatch();

  const customerContacts = useSelector(getCustomerContacts);

  const { register, getValues, handleSubmit } = useForm<{
    mainName: string;
    mainEmail: string;
    primaryName: string;
    primaryEmail: string;
    secondaryName: string;
    secondaryEmail: string;
  }>({
    defaultValues: {
      mainName: customerContacts?.main_contact_name,
      mainEmail: customerContacts?.main_contact_email,
      primaryName: customerContacts?.it_primary_contact_name,
      primaryEmail: customerContacts?.it_primary_contact_email,
      secondaryName: customerContacts?.it_secondary_contact_name,
      secondaryEmail: customerContacts?.it_secondary_contact_email,
    },
  });

  const onSubmit = (): void => {
    const { mainEmail, mainName, primaryEmail, primaryName, secondaryEmail, secondaryName } =
      getValues();

    dispatch(
      upsertCustomerContacts({
        main_contact_name: mainName,
        main_contact_email: mainEmail,
        it_primary_contact_name: primaryName,
        it_primary_contact_email: primaryEmail,
        it_secondary_contact_name: secondaryName,
        it_secondary_contact_email: secondaryEmail,
      })
    );

    toggleModalOpen();
  };

  const handleSaveButton = (): void => {
    handleSubmit(onSubmit)();
  };

  const renderEditContacts = (
    <div className=" w-full flex flex-row py-6 text-body">
      <form className="w-full h-full flex flex-row gap-10">
        <div className="pl-4 w-1/2 flex flex-col gap-2">
          <p>
            <b>Main Point of Contact</b>
          </p>
          <label htmlFor="mainName" className="flex flex-col gap-2 text-body">
            <div className="flex flex-row gap-1">
              <span>Name</span>
              <span className="litlingo-red-color">*</span>
            </div>

            <input
              id="mainName"
              type="text"
              ref={register({ required: true, pattern: /\S/i })}
              name="mainName"
              className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
            />
          </label>
          <label htmlFor="mainEmail" className="flex flex-col gap-2 text-body">
            <div className="flex flex-row gap-1">
              <span>Email</span>
              <span className="litlingo-red-color">*</span>
            </div>

            <input
              id="mainEmail"
              type="text"
              ref={register({ required: true, pattern: /\S/i })}
              name="mainEmail"
              className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
            />
          </label>
        </div>

        <div className="mb-20 border-r border-litlingo-gray-3" />

        <div className="w-1/2 flex flex-col gap-6">
          <div className=" w-1/2 flex flex-col gap-2">
            <p>
              <b>IT Primary Contact</b>
            </p>
            <label htmlFor="primaryName" className="flex flex-col gap-2 text-body">
              <div className="flex flex-row gap-1">
                <span>Name</span>
                <span className="litlingo-red-color">*</span>
              </div>

              <input
                id="primaryName"
                type="text"
                ref={register({ required: true, pattern: /\S/i })}
                name="primaryName"
                className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
              />
            </label>
            <label htmlFor="primaryEmail" className="flex flex-col gap-2 text-body">
              <div className="flex flex-row gap-1">
                <span>Email</span>
                <span className="litlingo-red-color">*</span>
              </div>

              <input
                id="primaryEmail"
                type="text"
                ref={register({ required: true, pattern: /\S/i })}
                name="primaryEmail"
                className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
              />
            </label>
          </div>

          <div className="w-1/2 flex flex-col gap-2">
            <p>
              <b>IT Secondary Contact</b>
            </p>
            <label htmlFor="secondaryName" className="flex flex-col gap-2 text-body">
              <div className="flex flex-row gap-1">
                <span>Name</span>
                <span className="litlingo-red-color">*</span>
              </div>

              <input
                id="secondaryName"
                type="text"
                ref={register({ required: true, pattern: /\S/i })}
                name="secondaryName"
                className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
              />
            </label>
            <label htmlFor="secondaryEmail" className="flex flex-col gap-2 text-body">
              <div className="flex flex-row gap-1">
                <span>Email</span>
                <span className="litlingo-red-color">*</span>
              </div>

              <input
                id="secondaryEmail"
                type="text"
                ref={register({ required: true, pattern: /\S/i })}
                name="secondaryEmail"
                className="form-input h-9 w-88 p-2 text-body rounded placeholder-italic placeholder-litlingo-gray-6"
              />
            </label>
          </div>
        </div>
      </form>
    </div>
  );

  return (
    <>
      {isModalOpen && (
        <Modal
          body={renderEditContacts}
          title="Contacts"
          okButton
          okButtonText="Save"
          okButtonOnClick={handleSaveButton}
          toggleShowModal={toggleModalOpen}
          style={{ width: '65rem' }}
        />
      )}
    </>
  );
};

export default EditCustomerContactsModal;
